import React from "react";
import { Form } from "antd";
import { Select } from "antd";
import { KEYTYPELIST_QUERY } from "../../Apollo/Queries";
import { Query } from "react-apollo";

const KeyTypeList = (props) => {
  const { Option } = Select;

  const keyTypeHelper = () => {
    return (
      <Form layout="inline">
        <Form.Item label="Key Type" required>
          <Select placeholder="Select Key" style={{ minWidth: 200 }} />
        </Form.Item>
      </Form>
    );
  };
  return (
    <div>
      <Query query={KEYTYPELIST_QUERY}>
        {({ data, loading, error }) => {
          if (loading) return keyTypeHelper();
          if (error) return <p>ERROR</p>;
          return (
            <div>
              <Form layout="inline">
                <Form.Item
                  label="Key Type"
                  required={props.required ? false : true}
                >
                  <Select
                    showSearch
                    placeholder="Select Key"
                    style={{ minWidth: 200 }}
                    onChange={props.keyTypeChange}
                    labelInValue
                    value={props.value}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {data.keyTypeList.map((p) => {
                      return (
                        <Option key={p.id} value={p.id}>
                          {p.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Form>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default KeyTypeList;
